import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './HeroSection.css';

// IMPORT YOUR LOCAL VIDEO AND BROCHURE HERE
import heroVideo from '../Assets/storyfest/storyfestvideo.mp4'; 
import brochurePdf from '../Assets/storyfest/StoryfestBrochure.pdf'; 
// 👇 IMPORT THE LOGO HERE (Update the path if necessary)
import storyfestLogo from '../Assets/logos/storyfestlogo.png'; 

const HeroSection = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);

  // Bulletproof infinite loop handler
  const handleVideoEnded = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch((error) => {
        console.log("Video auto-play interrupted:", error);
      });
    }
  };

  return (
    <header className="storyfest-hero-section">
      
      {/* Background Video & Overlay */}
      <div className="storyfest-hero-video-wrapper">
        <video 
          ref={videoRef}
          autoPlay 
          loop 
          muted 
          playsInline 
          onEnded={handleVideoEnded}
          className="storyfest-hero-video"
          poster="https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?q=80&w=1920&auto=format&fit=crop"
        >
          <source src={heroVideo} type="video/mp4" />
        </video>
        {/* Cinematic Warm Brown Overlay */}
        <div className="storyfest-hero-overlay"></div>
        <div className="storyfest-hero-vignette"></div>
      </div>

      {/* Main Content Grid */}
      <div className="storyfest-hero-container">
        
        {/* LEFT SIDE: Editorial Typography */}
        <div className="storyfest-hero-content">
          
          {/* 👇 REPLACED TEXT META WITH LOGO */}
          <div className="storyfest-hero-logo-wrapper">
            <img 
              src={storyfestLogo} 
              alt="StoryFest Logo" 
              className="storyfest-hero-logo" 
            />
          </div>

          <h1 className="storyfest-hero-title">
            Where<br />
            Ghana's <span className="storyfest-text-glow">stories</span><br />
            come alive.
          </h1>
          
          <p className="storyfest-hero-description">
            Three days of books, culture, food, Made-in-Ghana 
            discoveries and shared wonder for the whole family.
          </p>
          
          <div className="storyfest-hero-actions">

            <button 
              onClick={() => navigate('/register')} 
              className="storyfest-btn-cta storyfest-btn-blue-earlybird"
            >
              <span>Register for Free to Experience StoryFest</span>
              <span className="storyfest-arrow">→</span>
            </button>
            
            {/* <button 
              onClick={() => navigate('/vendors')} 
              className="storyfest-btn-cta storyfest-btn-gold"
            >
              <span className="storyfest-btn-icon"></span> 
              <span>Vendor registration</span>
              <span className="storyfest-arrow">↗</span>
            </button> */}
                        
            <button 
              onClick={() => navigate('/believe')} 
              className="storyfest-btn-cta storyfest-btn-coral"
            >
              <span>Believe tickets</span>
              <span className="storyfest-arrow">↗</span>
            </button>
          </div>
        </div>

        {/* RIGHT SIDE: Premium Deep Blue Pass Card */}
        <div className="storyfest-hero-card-wrapper">
          <div className="storyfest-event-pass-card">
            
            {/* Decorative Corner Accents */}
            <div className="storyfest-corner storyfest-top-left"></div>
            <div className="storyfest-corner storyfest-top-right"></div>
            <div className="storyfest-corner storyfest-bottom-left"></div>
            <div className="storyfest-corner storyfest-bottom-right"></div>

            <div className="storyfest-card-header">
              <span className="storyfest-card-icon">📅</span>
              <span className="storyfest-card-label">SAVE THE DATES</span>
            </div>

            <div className="storyfest-card-date-block">
              <h2 className="storyfest-date-numbers">11—13</h2>
              <p className="storyfest-date-month">DECEMBER 2026</p>
            </div>

            <div className="storyfest-card-divider"></div>

            <div className="storyfest-card-header">
              <span className="storyfest-card-icon">📍</span>
              <span className="storyfest-card-label">THE VENUE</span>
            </div>

            <div className="storyfest-card-venue-block">
              <h3 className="storyfest-venue-name">Accra City Hotel</h3>
              <p className="storyfest-venue-location">Accra, Ghana</p>
            </div>

            <p className="storyfest-card-quote">"Three days. A thousand stories."</p>

            {/* Download Brochure Button */}
            <a 
              href={brochurePdf} 
              download="StoryFest-2026-Brochure.pdf" 
              className="storyfest-btn-brochure"
            >
              <span>⬇</span> Download Brochure
            </a>

          </div>
        </div>

      </div>
    </header>
  );
};

export default HeroSection;